import {
	defaultTQC2090_R01Dto,
	TQC2090_R01_COMP_CD,
	TQC2090_R01Dto,
	TQC2090_R01_INSPECT_TYPE,
} from "../Dto_TQC2090_R01";
import { formatDate } from "src/utils/string/stringUtil";

export const NICKEL_LINE = "CR";

const APPEARANCE_TYPE = "FML_CR";
const THICKNESS_TYPE = "FML_NI";
const APPEARANCE_SPEC = "흠집, 스크래치, 도금벗겨짐, 오염 없을것";
const THICKNESS_SPEC = "10 ~ 20 MM";
const DAY_NAMES = ["일", "월", "화", "수", "목", "금", "토"];

const ZINC_ITEMS = [{
	inspItemCd: "Q000120",
	specInspType: THICKNESS_TYPE,
	inspItemNm: "도금두께",
	specText: THICKNESS_SPEC,
	valueType: "NUMERIC",
}] as const;

const NICKEL_ITEMS = [{
	inspItemCd: "Q000100",
	specInspType: APPEARANCE_TYPE,
	inspItemNm: "외관",
	specText: APPEARANCE_SPEC,
	valueType: "PASS_FAIL",
}, {
	inspItemCd: "Q000120",
	specInspType: THICKNESS_TYPE,
	inspItemNm: "도금두께",
	specText: THICKNESS_SPEC,
	valueType: "NUMERIC",
}] as const;

export const getInspectionItemsByLine = (workplaceCd: string): TQC2090_R01Dto[] => {
	const items = workplaceCd === NICKEL_LINE ? NICKEL_ITEMS : ZINC_ITEMS;
	return items.map((item) => ({
		...defaultTQC2090_R01Dto,
		...item,
		compCd: TQC2090_R01_COMP_CD,
		workplaceCd,
		inspectType: TQC2090_R01_INSPECT_TYPE,
	}));
};

export const createMonthlyRows = (
	inspectYm: Date,
	items: TQC2090_R01Dto[],
	storedRows: TQC2090_R01Dto[],
): TQC2090_R01Dto[] => {
	const year = inspectYm.getFullYear();
	const month = inspectYm.getMonth();
	const lastDay = new Date(year, month + 1, 0).getDate();
	const storedMap = new Map(
		storedRows.map((row) => [`${row.dayOfMonth}:${row.inspItemCd}`, row]),
	);
	const rows: TQC2090_R01Dto[] = [];

	for (let day = 1; day <= lastDay; day += 1) {
		const inspectDt = new Date(year, month, day);
		for (const item of items) {
			const stored = storedMap.get(`${day}:${item.inspItemCd}`);
			rows.push({
				...defaultTQC2090_R01Dto,
				...item,
				...stored,
				inspItemCd: item.inspItemCd,
				specInspType: item.specInspType,
				inspItemNm: item.inspItemNm,
				specText: item.specText,
				valueType: item.valueType,
				inspectDt: formatDate(inspectDt),
				dayOfMonth: day,
				dayOfWeekNm: DAY_NAMES[inspectDt.getDay()],
			});
		}
	}
	return rows;
};

export const mergeNickelRows = (list: TQC2090_R01Dto[]): TQC2090_R01Dto[] => {
	const rowsByDay = new Map<number, TQC2090_R01Dto[]>();
	list.forEach((row) => {
		rowsByDay.set(row.dayOfMonth, [...(rowsByDay.get(row.dayOfMonth) ?? []), row]);
	});

	return Array.from(rowsByDay.values()).map((rows) => {
		const appearance = rows.find((row) => row.specInspType === APPEARANCE_TYPE) ?? rows[0];
		const thickness = rows.find((row) => row.specInspType === THICKNESS_TYPE);
		return {
			...appearance,
			thicknessInspItemCd: thickness?.inspItemCd ?? "",
			thicknessItemNm: thickness?.inspItemNm ?? "",
			thicknessSpecText: thickness?.specText ?? "",
			thicknessValueType: thickness?.valueType ?? "",
			thicknessInspectNo: thickness?.inspectNo ?? "",
			thicknessItemNo: thickness?.itemNo ?? "",
			thicknessFirstValue: thickness?.inspectValue1_1 ?? "",
			thicknessMiddleValue: thickness?.inspectValue2_1 ?? "",
			thicknessLastValue: thickness?.inspectValue3_1 ?? "",
		};
	});
};

export const splitNickelRow = (row: TQC2090_R01Dto): TQC2090_R01Dto[] => {
	const thicknessRow: TQC2090_R01Dto = {
		...row,
		itemCd: "",
		inspItemCd: row.thicknessInspItemCd,
		specInspType: THICKNESS_TYPE,
		inspItemNm: row.thicknessItemNm,
		specText: row.thicknessSpecText,
		valueType: row.thicknessValueType,
		inspectNo: row.thicknessInspectNo || row.inspectNo,
		itemNo: row.thicknessItemNo,
		inspectValue1_1: row.thicknessFirstValue,
		inspectValue2_1: row.thicknessMiddleValue,
		inspectValue3_1: row.thicknessLastValue,
	};
	return [row, thicknessRow];
};
